import { RouteName } from "@cosine/routes";
import { useRoute, useRouter } from "vue-router";

export default function (routeName: RouteName) {
  const router = useRouter();
  const route = useRoute();

  const routeQueryKeys = Object.keys(route?.query || {});
  if (routeQueryKeys.length > 0 && !routeQueryKeys.some((key) => key === "redirect")) {
    router.replace({
      ...route,
      query: {
        ...route.query,
        redirect: encodeURIComponent(router.resolve({
          name: routeName,
          query: route.query,
        }).fullPath),
      },
    });
  }
}
